import { /* ColorSchemeScript, */ MantineProvider } from "@mantine/core";

import { THEME } from "~/helpers/mantine";

const AppMantineProvider: FC<PropsWithChildren> = ({ children }) => (
  <>
    {/* <ColorSchemeScript defaultColorScheme="dark" /> */}
    <MantineProvider theme={THEME} defaultColorScheme="dark">
      {children}
    </MantineProvider>
  </>
);

export default AppMantineProvider;
